import OtherLiensBalanceSection from "../other-liens-balance/OtherLiensBalanceSection";
import SettlementPaymentsSection from "../payments/SettlementPaymentsSection";

export default function LowerContainer() {
  return (
    <div className="grid w-full grid-cols-1 gap-6 lg:grid-cols-2">
      <SettlementPaymentsSection />
      <OtherLiensBalanceSection />
    </div>
  );
}
